import { render, staticRenderFns } from "./CAP0530_co.vue?vue&type=template&id=70924140&"
import script from "./CAP0530_co.vue?vue&type=script&lang=js&"
export * from "./CAP0530_co.vue?vue&type=script&lang=js&"
import style0 from "./CAP0530_co.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
